import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { TextAnimationStep } from '../../element-editor/animation/text-animation.service';

@Component({
  selector: 'nw-text-animation-step-json-modal',
  templateUrl: './text-animation-step-json-modal.component.html',
  styleUrls: ['./text-animation-step-json-modal.component.scss'],
})
export class TextAnimationStepJsonModalComponent implements OnChanges {
  @Input() value?: TextAnimationStep;
  @Output() save = new EventEmitter<TextAnimationStep>();
  @Output() cancel = new EventEmitter<void>();

  text = '';
  error?: string;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['value']) {
      try {
        this.text = JSON.stringify(this.value ?? {}, null, 2);
        this.error = undefined;
      } catch (e: any) {
        this.text = '';
        this.error = e?.message || 'Failed to stringify value';
      }
    }
  }

  onCancel() {
    this.cancel.emit();
  }

  onFormat() {
    const obj = this.tryParse();
    if (!obj) return;
    this.text = JSON.stringify(obj, null, 2);
  }

  onReset() {
    this.text = JSON.stringify(this.value ?? {}, null, 2);
    this.error = undefined;
  }

  validate() {
    this.tryParse();
  }

  onSave() {
    const obj = this.tryParse();
    if (!obj) return;
    this.save.emit(obj as TextAnimationStep);
  }

  private tryParse(): any | undefined {
    try {
      const obj = JSON.parse(this.text || '{}');
      this.error = undefined;
      return obj;
    } catch (e: any) {
      this.error = e?.message || 'Invalid JSON';
      return undefined;
    }
  }
}
